import { createFileRoute } from '@tanstack/react-router'
import { agreementSearchSchema } from '@/features/agreements/filter-agreements/model/agreementSearch'
import { AgreementsPage } from '@/pages/agreements/ui/AgreementsPage'

export const Route = createFileRoute('/agreements')({
  validateSearch: agreementSearchSchema,
  component: AgreementsPage,
})
